export enum SubscriptionInterval {
  Month = 1,
  Year = 12,
}

export enum SubscriptionIntervalLabel {
  month = 'Month',
  year = 'Year',
}
